import { Navigate } from "react-router-dom";
import { getDefaultSection } from "../../utils/configAccess";

const DefaultConfigRedirect = () => {
  return <Navigate to={getDefaultSection()} replace />;
};

export default DefaultConfigRedirect;
